export const GET_STOCK_NOTIFICATION_SETTINGS_QUERY = `
  importStock {emails enabled roles { id name }}
  importPriceGroup {emails enabled roles { id name }}
  checkExistence {emails enabled roles { id name }}
`;
